import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FAQS } from '../mock';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQ = () => {
  // Inject FAQPage JSON-LD for SEO (Google rich results)
  useEffect(() => {
    const scriptId = 'faq-jsonld';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const data = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQS.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: {
          '@type': 'Answer',
          text: f.a
        }
      }))
    };

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <section className="py-24 lg:py-28" data-testid="home-faq">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="mb-14 text-center">
          <p className="section-label mb-4">FAQs</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.05]">
            Everything you might ask.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-[#111114] border border-white/10 rounded-xl px-6 data-[state=open]:border-[#F5CD1B]/30"
              data-testid={`home-faq-item-${i}`}
            >
              <AccordionTrigger className="text-left font-display text-lg text-white hover:text-[#F5CD1B] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 leading-relaxed pb-5">
                <p>{f.a}</p>
                {f.link && (
                  <Link to={f.link.to} className="mt-4 inline-flex items-center gap-2 text-[#F5CD1B] font-semibold group hover:text-white transition-colors">
                    {f.link.label} <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                  </Link>
                )}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
